import { ENV_PROD, ENV_LOCAL, ENV_DEV } from './env';

let backendHost = 'https://koboo3-test.openium.fr';
const apiVersion = 'v3';

if (process.env.REACT_APP_ENV) {
  if (process.env.REACT_APP_ENV === ENV_LOCAL) {
    backendHost = 'https://koboo2-master.openium.fr';
  } else if (process.env.REACT_APP_ENV === ENV_DEV) {
    backendHost = 'https://koboo3-api-dev.openium.fr';
  }
} else if (process.env.NODE_ENV === ENV_PROD) {
  backendHost = 'https://koboo3-api.openium.fr';
}

export const API_ROOT = `${backendHost}/api`;
export const API_VERSION_ROOT = `${API_ROOT}/${apiVersion}`;
export const BACKEND_HOST = backendHost;
export default API_ROOT;



// WEBPACK FOOTER //
// ./src/constants/api.js